const REQUEST_TERMINAL_STATUSES = "REQUEST_TERMINAL_STATUSES";
const RECEIVE_TERMINAL_STATUSES = "RECEIVE_TERMINAL_STATUSES";

export default {
    REQUEST_TERMINAL_STATUSES, 
    RECEIVE_TERMINAL_STATUSES
}